export enum DeclarationFilter {
  FDES = "FDES",
  PEP = "PEP",
}

export const declarationFilterEnumLabels = {
  [DeclarationFilter.FDES]: "Produits",
  [DeclarationFilter.PEP]: "Équipements (PEP)",
}
